import Vue from "vue"
import { required, email, max, min, min_value, max_value, confirmed } from "vee-validate/dist/rules"
import { extend, ValidationObserver, ValidationProvider } from "vee-validate"

extend("required", {
  ...required,
  message: "tidak boleh kosong"
});

extend("max", {
  ...max,
  message: "maksimal {length} karakter"
});

extend("min", {
  ...min,
  message: "minimal {length} karakter"
});

extend("min_10000", {
  ...min_value,
  message: "minimal 10000"
});

extend('min_1', {
  ...min_value,
  message: 'minimal 1'
})

extend("min_0", {
  ...min_value,
  message: "minimal 0"
});

extend("max_100", {
  ...max_value,
  message: "maksimal {max}"
});

extend("email", {
  ...email,
  message: "email belum benar"
})

extend("confirmed", {
  ...confirmed,
  message: "konfirmasi password belum benar"
});

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  }
}